// Create a class for the element
class BundleSelect extends HTMLElement {
  static observedAttributes = ["color", "size"];

  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {
    this.init()
  }
  init(){
    this.optionSelected = false;
    this.queryValue = this.getAttribute('selectfor');
    this.currentTitleDisplay = this.querySelector('[select_mask_current_title]');
    if(!!this.queryValue){
        this.optionsDisplay = this.querySelector('[mask_options]');
        this.onclick = (e)=>{
          // remove error class
          this.classList.remove('submit_error');
            if (!this.hasAttribute('active')){
              //opening options -> only allow one select to be active
              const activeBundleSelects = document.querySelectorAll('bundle-select[active]');

              activeBundleSelects.forEach((bundleSelect)=>{
                bundleSelect.removeAttribute('active');
              })
            } 
            this.toggleAttribute('active');
        }
        this.options = this.querySelectorAll('[mask_option]');
        this.options.forEach((option)=>{
            option.onclick = (e)=>{
                //update select value
                const realSelect = this.querySelector(`[input_for_mask="${this.queryValue}"]`);
                if(realSelect){
                    realSelect.value = option.getAttribute('value');
                    this.optionSelected = true;
                    //update dom (image&title)
                    // title
                    const optionTitleElement = option.querySelector('[mask_option_title]');
                    if(optionTitleElement ){
                        const optionTitle = optionTitleElement.getAttribute('mask_option_title');
                        if(optionTitle && this.currentTitleDisplay){
                            this.currentTitleDisplay.innerHTML = optionTitle;
                        }
                    }
                    //image 
                    const optionImageContainer = option.querySelector('[mask_option_image_container]');
                    const selectedOptionImageContainer = this.querySelector('[selected_option_image_container]');
                    if(!!optionImageContainer & !!selectedOptionImageContainer){
                        selectedOptionImageContainer.innerHTML = optionImageContainer.innerHTML;
                    }
                }
            }
        })
    }
    //validation
    this.form = this.closest('form');
    if(this.form){
       this.atc = this.form.querySelector('button[type="submit"]');
       this.atc.addEventListener('click', (e)=>{
        if(this.optionSelected == false){
          //no variant was selected
          this.classList.add('submit_error');
        }
       })
    }
  }

}

customElements.define("bundle-select", BundleSelect);
